import React, { forwardRef } from 'react'

import AgentButton from '~/components/agent/AgentButton'

export interface LeftMenuAgentButtonProps {
  className?: string
  isMenuExpanded?: boolean
  onClick?: (event: React.MouseEvent) => void
}

/**
 * Wrapper component that integrates the AgentButton into the left menu system.
 * This component handles the connection between the left menu's expanded/collapsed state
 * and the AgentButton's appearance.
 *
 * @param isMenuExpanded - Controls whether the button displays in expanded (with text) or collapsed (icon-only) mode.
 *                         When false or undefined, the button shows as icon-only.
 */
const LeftMenuAgentButton = forwardRef<
  HTMLDivElement,
  LeftMenuAgentButtonProps
>(function LeftMenuAgentButton(
  { className, isMenuExpanded, onClick, ...rest },
  ref,
) {
  return (
    <div className={className} ref={ref} {...rest}>
      <AgentButton isMenuExpanded={isMenuExpanded} onClick={onClick} />
    </div>
  )
})

export default LeftMenuAgentButton
